export enum QSTeamPermissionEnum {
    None = 0x00,
    CanView = 0x01 << 1,
    CanSeeAll = 0x01 << 2,
    CanEditRevision = 0x01 << 3,
    CanFinaliseRevision = 0x01 << 4,
    CanApproveManualOrder = 0x01 << 6
}
